// removed by extract-text-webpack-plugin
module.exports = {"support-business-wrap":"support-business-wrap","block-support-business":"block-support-business","support-business-img":"support-business-img","support-business-content":"support-business-content","title":"title","content":"content","description":"description","support-business-box-redirect":"support-business-box-redirect","redirect-link":"redirect-link","fa-arrow-circle-right":"fa-arrow-circle-right"};


//////////////////
// WEBPACK FOOTER
// ./components/users/sub-view/support-business/style.scss
// module id = ./components/users/sub-view/support-business/style.scss
// module chunks = 0